import React, { useEffect, useState } from 'react'
import axios from '../../../utils/axios'
import CustomTable from '../../molecules/table/table'
import { useAuth } from '../../../customHooks/useAuth'
import { t } from '../../../utils/i18n'
import './linked-accounts.scss'
import NoData from '../../molecules/no-data/no-data'

interface ILinkedAccounts {
  pageRefresh: boolean
}

const LinkedAccounts = ({ pageRefresh }: ILinkedAccounts) => {
  const [linkAccounts, setLinkedAccounts] = useState([])
  const [isLoading, SetIsLoading] = useState(true)
  const { user } = useAuth()

  useEffect(() => {
    getAccounts()
  }, [pageRefresh])

  const getAccounts = async () => {
    const config = {
      url: process.env.REACT_APP_LINK_ACCOUNTS,
      method: 'GET',
      headers: {
        'x-user': user?.email,
        'x-access-token': user?.tokens?.accessToken?.token,
        'x-source': user?.isSSO ? 'sso' : null,
      },
    }
    const res = await axios(config)

    if (res?.data?.data) {
      SetIsLoading(true)
      setLinkedAccounts(res?.data?.data?.data)
      SetIsLoading(false)
    }
  }

  const columns = [
    { key: 'linkedEmail', label: 'Email Address', flexGrow: 1 },
    { key: 'linkedDate', label: 'Linked Date', flexGrow: 1 },
  ]

  return (
    <section className="linked-acc-section">
      <h1>{t('linked.accounts.title')}</h1>
      <p className="body-sm">{t('linked.accounts.desc')}</p>
      {isLoading ? (
        <div className="link-acc-pulsating" />
      ) : linkAccounts?.length ? (
        <CustomTable data={linkAccounts} columns={columns} isLoading={isLoading} />
      ) : (
        <NoData message={t('no.linked.accounts')} />
      )}
    </section>
  )
}

export default LinkedAccounts
